import React, {useState} from 'react';
import logo from './logo.svg';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { auth } from "./config/FirebaseConfig";
import { signOut } from "firebase/auth";
import Login from "./pages/Login"
import Home from "./pages/Home"
import MyConfessions from "./pages/MyConfessions"
import NavBar from "./utilities/components/NavBar"
import ConfessionPage from "./pages/ConfessionPage"
import About from "./pages/About"
import DisplaySingleConfession from "./pages/DisplaySingleConfession"
import styles from "./App.module.css";
import useStore from "./store"


function App() {

  const [isAuth, setIsAuth] = useState(localStorage.getItem("isAuth"))

  const storeUserData = useStore((state) => state.storeUserData);
  storeUserData(JSON.parse(localStorage.getItem("userData")))
console.log("kkkk", JSON.parse(localStorage.getItem("userData")))

  const signUserOut = () => {
    signOut(auth).then(() => {
      localStorage.clear();
      setIsAuth(false);
      window.location.pathname = "/login";
    });
  };

  return (
    <Router>
      <div className={styles.App}>
        <NavBar isAuth={isAuth} signUserOut={signUserOut}/>
        <div className={styles.routersContainer}>
          <Routes>
            <Route path="/sfu" element={<Home isAuth={isAuth} />} />
            {
              //should redirect to /sfu
            }
            <Route path="/" element={<Home isAuth={isAuth} />} />
            <Route path="/myConfessions" element={<MyConfessions isAuth={isAuth} />} />
            <Route path="/addConfession" element={<ConfessionPage />} />
            <Route path="/login" element={<Login setIsAuth={setIsAuth} />}/>
            <Route path="/:id" element={<DisplaySingleConfession isAuth={isAuth} />}/>
            <Route path="/signout" element={<Login />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
